import { Button, ButtonType } from '@resurs-internal/styx-react'
import React, { useState } from 'react'
import styles from './Mock.module.scss'

export const UseRealServiceButton = ({ apiPath }) => {
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)

  const handleClick = async () => {
    setLoading(true)
    setError(null)
    try {
      const resp = await fetch(apiPath, { method: 'POST' })
      if (!resp.ok) throw new Error(`HTTP ${resp.status}`)
      const data = await resp.json()
      window.location.href = data.realUrl
    } catch (e) {
      setError('Failed to switch to real service')
      setLoading(false)
    }
  }

  return (
    <>
      <div className={styles.lineWrapper}>
        <Button
          id="useRealServiceBtn"
          type={ButtonType.Secondary}
          fullWidth
          outline
          onClick={handleClick}
          disabled={loading}
        >
          {loading ? 'Switching...' : 'Use Real Service'}
        </Button>
      </div>
      {error && (
        <p
          style={{
            color: '#DE332A',
            fontSize: '0.875rem',
            marginTop: '0.25rem',
          }}
        >
          {error}
        </p>
      )}
    </>
  )
}
